<template>
  <div class="acomodar">
    <div class="container-fluid py-3 px-2 px-md-4">
      
      <!-- BOTÓN RETROCEDER -->
      <button class="btn btn-danger mb-3" @click="retroceder">
        <i class="bi bi-skip-backward"></i>
      </button>

      <!-- ENCABEZADO -->
      <div class="border border-1 rounded-3 p-3 mb-4">
        <div class="d-flex align-items-center gap-3 flex-wrap">
          <i class="bi bi-check2-square display-4 text-primary"></i>
          <div>
            <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
              ETAPA DE SELECCIÓN
            </p>
            <p class="mb-0 tituloResaltado fs-4 fw-bold">
              DATOS GENERALES
            </p>
          </div>
        </div>
      </div>

      <!-- FORM + TABLA -->
      <form @submit.prevent="GrabarEntrevista">
        <div class="row gx-3 gy-3">

          <!-- FORMULARIO -->
          <div :class="{ 'col-12 col-lg-4 order-1': true, 'd-none': permisoVisualizador == 11 }">
            <div class="border border-1 p-3 rounded-3">

              <!-- TIPO DE ENTREVISTA -->
              <div class="mb-3">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi bi-chat-left-text text-primary fs-6"></i>
                  TIPO DE ENTREVISTA:
                </label>
                <select class="form-select" @change="EscogerEntrevistador($event)" v-model="selected">
                  <option disabled value="seleccionar">Seleccionar tipo...</option>
                  <option v-for="items in entrevista" :key="items.id" :value="items.parCorrelativo">
                    {{ items.parDescripcion }}
                  </option>
                </select>
              </div>

              <!-- ENTREVISTADOR -->
              <div class="mb-3">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi bi-person-badge text-success fs-6"></i>
                  ENTREVISTADOR:
                </label>
                <select class="form-select" @change="IdEntrevistador($event)" v-model="selected1">
                  <option disabled value="seleccionar1">Seleccionar Entrevistador...</option>
                  <option v-for="entrevistadores in entrevistador" 
                          :key="entrevistadores.id" 
                          :value="entrevistadores.idTrabajador">
                    {{ entrevistadores.nombreTrabajador }}
                  </option>
                </select>
              </div>

              <!-- RESULTADO DE LA ENTREVISTA -->
              <div class="mb-3">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi bi-journal-text text-warning fs-5"></i>
                  AGENDA Y RESULTADO DE LA ENTREVISTA:
                </label>
                <textarea v-model="form.entrevistaResultado" class="form-control" rows="4" placeholder="Escriba aquí el detalle de la entrevista"></textarea>
              </div>

              <!-- ESTADO -->
              <div class="mb-3">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi bi-flag text-danger fs-6"></i>
                  ESTADO:
                </label>
                <select class="form-select" @change="EstadosParams($event)" v-model="selected2">
                  <option disabled value="seleccionar2">Seleccionar estado...</option>
                  <option v-for="estadosUnicos in estados" 
                          :key="estadosUnicos.id"
                          :value="estadosUnicos.parCorrelativo">
                    {{ estadosUnicos.parDescripcion }}
                  </option>
                </select>
              </div>

              <!-- BOTÓN GUARDAR -->
              <div class="text-center mt-3">
                <button type="submit" :disabled="isSaving" class="btn btn-success">
                  <i class="bi bi-floppy fs-5"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- TABLA -->
          <div class="col-12 col-lg-8 order-2">
            <div class="border border-1 h-100 p-3 rounded-3">

              <!-- BUSCADOR -->
              <div class="d-flex flex-column flex-md-row justify-content-end mb-3 gap-2">
                <label class="me-2 mt-2 tamaño">Buscar:</label>
                <input class="form-control form-control-lg w-25 mt-1 tamaños" type="text"
                       placeholder="TIPO DE ENTREVISTA.." v-model="filterField" />
              </div>

              <!-- TABLA -->
              <div class="table-responsive">
                <table class="table table-bordered mb-0">
                  <thead>
                    <tr class="bg-solimano-table text-white text-center text-nowrap tamaño2">
                      <th>ID</th>
                      <th>TIPO</th>
                      <th>ENTREVISTADOR</th>
                      <th>RESULTADO (FEEDBACK)</th>
                      <th>ESTADO</th>
                      <th v-if="permisoVisualizador == 2">ACCIÓN</th>
                    </tr>
                  </thead>

                  <!-- SPINNER DE CARGA -->
                  <tbody v-if="loading">
                    <tr>
                      <td colspan="6" class="text-center py-5">
                        <div class="spinner-border text-primary" role="status"></div>
                        <p class="mt-2 text-muted fw-bold">Cargando datos...</p>
                      </td>
                    </tr>
                  </tbody>

                  <!-- DATOS -->
                  <tbody v-else>
                    <tr v-for="post in paginatedPosts" :key="post.idEntrevista" class="tamaños text-nowrap align-middle">
                      
                      <td>
                        <i class="text-start"></i>
                        {{ post.idEntrevista }}
                      </td>

                      <td class="text-start">
                        <i class="bi bi-ui-checks-grid text-success me-2"></i>
                        {{ post.entrevistaTipo }}
                      </td>

                      <td>
                        <i class="bi bi-person-circle text-info me-2"></i>
                        {{ post.nomEntrevistador }}
                      </td>

                      <td>
                        <i class="bi bi-chat-left-dots text-warning me-2"></i>
                        {{ post.entrevistaResultado }}
                      </td>

                      <td class="text-center fw-semibold"
                          :class="{
                            'text-success fw-bold': post.entEstado === 'APTO',
                            'text-danger fw-bold': post.entEstado === 'NO APTO',
                            'text-warning fw-bold': post.entEstado === 'PENDIENTE'
                          }">
                        <i :class="{
                          'bi bi-check-circle-fill': post.entEstado === 'APTO',
                          'bi bi-x-circle-fill': post.entEstado === 'NO APTO',
                          'bi bi-hourglass-split': post.entEstado === 'PENDIENTE'
                        }" class="me-2"></i>
                        {{ post.entEstado }}
                      </td>

                      <td v-if="permisoVisualizador == 2" class="text-center">
                        <button class="btn btn-danger" @click="Eliminar(post.idEntrevista)">
                          <i class="bi bi-trash"></i>
                        </button>
                      </td>

                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- PAGINACIÓN -->
              <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
                <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
                  <i class="bi bi-chevron-double-left"></i>
                </button>
                <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
                  <i class="bi bi-chevron-left"></i>
                </button>
                <span class="pagination-info fw-bold">
                  Página {{ currentPage }} de {{ totalPages }}
                </span>
                <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
                  <i class="bi bi-chevron-right"></i>
                </button>
                <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages" :disabled="currentPage === totalPages">
                  <i class="bi bi-chevron-double-right"></i>
                </button>
              </div>

            </div>
          </div>

        </div>
      </form>
    </div>
  </div>
</template>



<script>
import swal from "sweetalert";
import Swal from "sweetalert2";
export default {
  name: "SolimanologDatosEntrevista",

  data() {
    return {

      filterField: "",
      cerrarTable1: true,
      cerrarTable2: false,
      currentPage: 1,
      itemsPerPage: 6,
      loading: false,

      entrevista: [],
      entrevistador: [],
      estados: [],
      selected: "seleccionar",
      selected1: "seleccionar1",
      selected2: "seleccionar2",
      form: {
        idUsuario: "",
        idSolxPostulante: "",
        entrevistaTipo: "",
        entrevistaResultado: "",
        idEntrevistador: "",
        entEstado: "",
      },

      posts: [],
      alertaError: false,
      isSaving: false,
      dismissSecs: 2,
      dismissCountDown: 0,

      permisoVisualizador: null,
    };
  },

  computed: {

    totalPages() {
      return Math.ceil(this.posts.length / this.itemsPerPage);
    },

    paginatedPosts() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.posts.slice(start, start + this.itemsPerPage);
    }
  },
  watch: {
  filterField() {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
    }, 800);
  }
},


  mounted() {
    this.form.idUsuario = localStorage.getItem("userId")
    this.permisoVisualizador = localStorage.getItem("idPerfil")

    this.form.idSolxPostulante = this.$route.params.parametro;
    console.log(this.$route.params.parametro);
    this.axios
      .get("Entrevista/ListaEntrevistaxPos/" + this.$route.params.parametro)
      .then((r) => {
        this.entrevista = r.data;
        // console.log(this.entrevista)
      });

    this.axios.get("ParametroData/Parametro/7523").then((r) => {
      this.estados = r.data;
      // console.log(r.data)
    });

    this.axios
      .get("Entrevista/ObtenerEntrevista/" + this.form.idSolxPostulante)
      .then((r) => {
        this.posts = r.data;
        console.log(this.posts);
      });
  },


  created() {
    this.cambiarEstadoNavbar();
  },



  methods: {
    
    filter(items) {
      // aqui nos aseguramos que el input contenga caracteres String y que valida
      // el v-model de this.nombre
      console.log(items.idEntrevista);
      return (
        items.entEstado
          .toLocaleLowerCase()
          .indexOf(this.filterField.toLocaleLowerCase()) >= 0
      );
    },
  
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },


    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

    getAttributes() {
      this.axios
        .get("Entrevista/ObtenerEntrevista/" + this.$route.params.parametro)
        .then((r) => {
          this.posts = r.data;
          console.log(this.posts);
        });
    },
    Eliminar(id) {
      Swal.fire({
        title: "Estas seguro de Eliminar?",

        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Eliminar!!",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire("¡Eliminado!", "El registro ha sido eliminado con éxito", "success");
          this.axios.delete(`Entrevista/EliminarEntrevista?idEntrevista=${id}&idSolxPostulante=${this.form.idSolxPostulante}`).then((r) => {
            console.log(r.data);
            this.getAttributes();
          });
        }
      });
    },

    retroceder() {
      window.history.back();
    },
    GrabarEntrevista() {
      console.log(this.form)

      if (
        this.form.idSolxPostulante == "" ||
        this.form.entrevistaTipo == "" ||
        this.form.entrevistaResultado == "" ||
        this.form.idEntrevistador == "" ||
        this.form.entEstado == ""
      ) {
        this.alertaError = true;
        setTimeout(() => {
          this.alertaError = false;
        }, 2500);
      } else {
        this.isSaving = true;
        this.axios
          .post("Entrevista/RegistrarEntrevista", this.form)
          .then((r) => {
            console.log(r.data)
            if (r.data == true) {
              swal("Gracias", "Se Registro Entrevista!", "success");
              this.form.entrevistaResultado = "";
              (this.selected = "seleccionar"),
                (this.selected1 = "seleccionar1"),
                (this.selected2 = "seleccionar2"),
                (this.alertaError = false);
              this.getAttributes();
            }
          })
          .finally(() => {
            this.isSaving = false;
          });
      }
    },

    EscogerEntrevistador(event) {
      console.log(event.target.value);
      this.form.entrevistaTipo = event.target.value;

      this.axios
        .get("Entrevista/ListaEntrevistaxRes/" + event.target.value)
        .then((r) => {
          this.entrevistador = r.data;
          console.log(r.data)
        });
    },

    IdEntrevistador(event) {
      console.log(event.target.value)
      this.form.idEntrevistador = event.target.value;
    },

    EstadosParams(event) {
      this.form.entEstado = event.target.value;
    },


  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(22, 22, 22, 0.2) 0px 2px 8px 0px;
  width: 100%;
  /* margin-right: 0.5rem !important; */
  margin-left: 0.5%;
  margin-right: 0.5%;
  margin-top: 9px;
  margin-bottom: 9px;
  background: rgb(255, 255, 255);
  min-height: 100vh;
  overflow-x: auto;
  overflow-y: hidden;
}

.tamaño {
    font-size: 0.65rem;

    font-weight: 800;
    color: #002c5d;
}
.tamaños{
  font-size: 0.65rem;
}
.tamaño2 {
  font-size: 0.65rem;
  font-weight: 800;
}



.titulo {
  color: #0080c8;
  text-decoration: underline;
  
}


.bg-solimano {
  border-color: #0080c8;
  border-width: 2px;
}

.bg-solimano-table{
  background: #0080c8;
}

.btn-solimano{
  background: #0080c8;
}

.tituloColorMas {
  /* color: #002c5d; */
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}
</style>
